import type { ViewProps } from 'react-native'
import type { LayoutType, TTooltipSide } from '~/components/tooltip/types'
import { PositionDirection } from '~/components/tooltip/types/enums'
import { ArrowSvg } from '~/components/arrow-svg'
import { useTheme } from '~/hooks/use-theme'
import { useTooltipArrowStyles } from './tooltip-arrow.styles'

interface TTooltipArrowProps extends ViewProps {
  side: TTooltipSide
  triggerLayout: LayoutType
  contentLayout?: LayoutType
}

export function TooltipArrow({
  side,
  triggerLayout,
  contentLayout,
  style,
  ...rest
}: TTooltipArrowProps) {
  const Comp = useTooltipArrowStyles()

  const theme = useTheme()
  const ARROW_WIDTH = theme.sizingTiny

  const getTransform = () => {
    const HALF_DIVISOR = 2

    if (side === PositionDirection.BOTTOM || side === PositionDirection.TOP) {
      const triggerCenterX =
        (triggerLayout?.x || 0) + (triggerLayout?.width || 0) / HALF_DIVISOR
      return {
        translateX: triggerCenterX - ARROW_WIDTH / 2,
      }
    }

    return {
      translateY: 0,
    }
  }

  return (
    <Comp.Wrapper
      side={side}
      style={{
        transform: [getTransform()],
      }}
    >
      <Comp.Arrow {...rest} side={side}>
        <ArrowSvg />
      </Comp.Arrow>
    </Comp.Wrapper>
  )
}
